import styled from 'styled-components';

export const StyledMatrixContainer = styled.div`
  position: relative;
  display: flex;
  /* center when it fits, but fall back to start so an overflowing matrix stays
     reachable inside the parent's horizontal scroll (centering would clip the
     left edge out of scroll range) */
  justify-content: safe center;
  align-items: center;
  width: 100%;
`;

export const StyledMatrixWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const StyledLikelihoodText = styled.div`
  position: absolute;
  left: -40px;
  top: 50%;
  transform: translateY(-50%) rotate(-90deg);
  font-size: 12px !important;
  font-weight: 400 !important;
  color: ${({ theme }) => theme.palette.text.disabled};
  white-space: nowrap;
  z-index: 1;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 30px;
    height: 1px;
    background-color: ${({ theme }) => theme.palette.text.disabled};
  }

  &::before {
    right: 100%;
    margin-right: 8px;
  }

  &::after {
    left: 100%;
    margin-left: 8px;
  }
`;

export const StyledImpactText = styled.div`
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px !important;
  font-weight: 400 !important;
  color: ${({ theme }) => theme.palette.text.disabled};
  white-space: nowrap;
  z-index: 1;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 60px;
    height: 1px;
    background-color: ${({ theme }) => theme.palette.text.disabled};
  }

  &::before {
    right: 100%;
    margin-right: 8px;
  }

  &::after {
    left: 100%;
    margin-left: 8px;
  }
`;

export const StyledLikelihoodCell = styled.div`
  height: 72px;
  width: 90px;
  border: none;
  padding: 10px 2px;
  display: flex;
  font-size: 12px;
  position: relative;
  align-items: center;
  border-right: 1px solid ${({ theme }) => theme.palette.grey[400]};
  justify-content: center;
  text-align: center;
`;

export const StyledRiskMatrix = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  border-right: none;
  border-radius: 4px;
`;

export const StyledRiskMatrixSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
`;

export const StyledRiskMatrixSummaryItem = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

export const StyledRiskMatrixSummaryItemValue = styled.span<{ color: string; backgroundColor: string }>`
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
`;
